export default __webpack_public_path__ + "static/media/social_media_reactJS.c0d9982b.PNG";